import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d6deb950&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d6deb950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6deb950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6deb950')) {
      api.createRecord('d6deb950', component.options)
    } else {
      api.reload('d6deb950', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d6deb950&scoped=true&", function () {
      api.rerender('d6deb950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/city-insurance-entry/modules/editConfig/index.vue"
export default component.exports